module.exports = __webpack_public_path__ + "img/circle-arrow-up-left.cc69f7cd.svg";